import React from 'react';
import ProfileSettingsFragment from '@app/site/secured/general-settings/fragment/general/ProfileSettingsFragment';
import ProfileChangePasswordFragment from '@app/site/secured/general-settings/fragment/general/ProfileChangePasswordFragment';
import useSiteState from '@app/state/SiteState';
import AuthProvider from '@app/model/authentication/AuthProvider';


const GeneralSettingsFragment = React.memo(()=>{

    const principal = useSiteState(state => state.principal);

    return <div className="mx-auto max-w-2xl space-y-16 sm:space-y-20 lg:mx-0 lg:max-w-none bg-white p-4 sm:p-10 rounded-xl">
        <div>
            <header className="border-b border-gray-200 pb-4 mb-8"><h2
                className="text-base font-semibold leading-7 text-gray-900">Personal Information</h2><p
                className="text-sm leading-6 text-gray-500">Manage the relevant fields associated with your account.</p>
            </header>
            <div className="lg:col-span-9">
                <ProfileSettingsFragment/>
                {principal!.authProviders.includes(AuthProvider.LOCAL) && <ProfileChangePasswordFragment/>}
            </div>
        </div>

    </div>
})

export default GeneralSettingsFragment;